import { safeResolveAsync } from '../../utils';
import { OK } from 'http-status-codes';
import { debounce, put } from 'redux-saga/effects';

import { ACTION_WAIT_DEBOUNCE_TIME_MS } from '../../constants';
import { takeAuth, takeLogout } from '../auth';
import * as api from './api';
import { actions, types } from './duck';

export function* getCityList({ provinceName, resolve }) {
  try {
    yield put(actions.getCityListRequest());

    const response = yield api.getCityList(provinceName);
    if (response.status === OK) {
      yield put(actions.getCityListSuccess(response.data));
      yield safeResolveAsync(resolve, response.data);
    } else {
      yield put(actions.getCityListFailure(response.data.detail));
    }
  } catch (error) {
    yield put(actions.getCityListFailure(error.message));
  }
}

export function* initialize() {
  yield put(actions.getCityList());
}

export function* clear() {
  yield put(actions.reset());
}

export default function* saga() {
  // We use debounce here to prevent
  // double saga call in case of initializing
  // on page with effect to call this saga.
  yield debounce(ACTION_WAIT_DEBOUNCE_TIME_MS, types.GET_CITY_LIST, getCityList);
  yield takeAuth(initialize);
  yield takeLogout(clear);
}
